import { Controller } from 'stimulus';
import formatPrice from '@/helpers/formatPrice';

class BookingFormController extends Controller {
  connect() {
    this.inputTargets.forEach((input) => {
      if (typeof input.dataset.rowTarget === 'undefined') {
        return;
      }

      this.updateRow(
        input.dataset.rowTarget,
        parseFloat(input.dataset.price),
        parseInt(input.value, 10),
      );
    });

    this.calculateTotal();
    this.validateAmountOfPersons();
  }

  onInputChange({ target }) {
    if (typeof target.dataset.rowTarget === 'undefined') {
      return;
    }

    this.updateRow(
      target.dataset.rowTarget,
      parseFloat(target.dataset.price),
      parseInt(target.value, 10),
    );

    this.calculateTotal();
    this.validateAmountOfPersons();
  }

  updateRow(row, price, value) {
    const rowElement = this[`${row}RowTarget`];
    const priceElement = this[`${row}PriceTarget`];
    const amountElement = this[`${row}AmountTarget`];

    rowElement.hidden = value === 0;
    priceElement.innerHTML = formatPrice(price * value);
    amountElement.innerText = value;
  }

  validateAmountOfPersons() {
    if (!this.data.has('maximum-amount-of-persons')) return;

    const maximumAmountOfPersons = parseInt(this.data.get('maximum-amount-of-persons'), 10);
    const totalAmountOfPersons = this.calculateAmountOfPersons();

    this.errorTarget.hidden = totalAmountOfPersons <= maximumAmountOfPersons;
    this.submitTarget.disabled = totalAmountOfPersons > maximumAmountOfPersons;
  }

  calculateAmountOfPersons() {
    return this.inputTargets.reduce((acc, input) => acc + parseInt(input.value, 10), 0);
  }

  calculateTotal() {
    const total = this.inputTargets.reduce((acc, input) => {
      const price = input.dataset.price * input.value;

      return acc + price;
    }, 0);

    this.totalTarget.innerHTML = formatPrice(total);
  }
}

BookingFormController.targets = [
  'input',
  'total',
  'submit',
  'error',

  'adultsRow',
  'adultsPrice',
  'adultsAmount',

  'childrenRow',
  'childrenPrice',
  'childrenAmount',

  'babiesRow',
  'babiesPrice',
  'babiesAmount',
];

export default BookingFormController;
